import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-csv-upload-dialog',
    templateUrl: './csv-upload-dialog.component.html',
    styleUrls: ['./csv-upload-dialog.component.css'],
})
export class CsvUploadDialogComponent implements OnInit {
    jahrCtrl = new UntypedFormControl();
    halbjahrCtrl = new UntypedFormControl();

    csvFile: File;
    fileName: string;

    constructor(
        public dialogRef: MatDialogRef<CsvUploadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private http: HttpClient,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        let d = new Date();
        if (d.getMonth() > 5) {
            this.halbjahrCtrl.setValue(1);
            this.jahrCtrl.setValue(d.getFullYear() + 1);
        } else {
            this.halbjahrCtrl.setValue(2);
            this.jahrCtrl.setValue(d.getFullYear());
        }
    }

    onFileSelected(event) {
        this.csvFile = event.target.files[0];
        if (this.csvFile) {
            this.fileName = this.csvFile.name;
        }
    }

    close() {
        this.dialogRef.close(null);
    }

    upload() {
        let fd = new FormData();
        if (this.csvFile) {
            fd.append('dokument', this.csvFile, this.fileName);
        }
        fd.append('jahr', this.jahrCtrl.value);
        fd.append('halbjahr', this.halbjahrCtrl.value);

        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.http.post(this.apiBaseUrl + 'massnahmenplan_rind/mnp_rind_schwein_generieren.php', fd, options).subscribe(
            () => {
                this.messageService.infoMessage('Die Maßnahmenpläne wurden erfolgreich angelegt!');
                this.close();
            },
            error => {
                this.messageService.errorMessage('Die Maßnahmenpläne konnten nich hochgeladen werden!', error);
            },
        );
    }
}
